import { callSecurityAPI, HTTPMethod } from "./API";
import { ClientSsoConfig } from "../model/TenantConfiguration";

export async function getClientSsoConfig(tenantId: string, headers: Record<string, string>): Promise<ClientSsoConfig> {
    return await callSecurityAPI(`/tenants/${tenantId}/client-sso-config`, {
        method: HTTPMethod.GET,
        headerParams: headers
    });
}